module.exports = __webpack_public_path__ + "static/media/logo-mattdb.b50613c5.svg";